import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-file-cog-outline',
  templateUrl: './icon-file-cog-outline.component.html',
  styleUrl: './icon-file-cog-outline.component.scss',
  standalone: false,
})
export class IconFileCogOutlineComponent {
  @Input() tooltip?: string;
}
